"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.delay = delay;
exports.cancelableDelay = void 0;

var _dist = require("api-fetcher-treeline/dist");

// Number, Any -> Promise
// Timer function
function delay(t, v) {
  return new Promise(function (resolve) {
    setTimeout(resolve.bind(null, v), t);
  });
}

var cancelableDelay = function cancelableDelay(t, v) {
  return (0, _dist.makeCancelable)(delay(t, v));
};

exports.cancelableDelay = cancelableDelay;